import { Fragment, ReactElement, useMemo } from 'react';
import { CivilUnionDetailNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionDetailNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CivilUnionDetailNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CivilUnionDetailNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CivilUnionDetailNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import RegistrationCivilUnionNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-civil-union-non-resident/detail';

interface ResearchCivilUnionDetailNotificationsPageProps {
  scope?: string;
  isOther?: boolean;
}

const RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared = ({
  scope,
  isOther,
}: ResearchCivilUnionDetailNotificationsPageProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return CivilUnionDetailNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CivilUnionDetailNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CivilUnionDetailNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CivilUnionDetailNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CivilUnionDetailNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  const editSipoUrl = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`;
  }, [goBackUrl]);

  const goBackUrlPage = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentNotificationShared
        editSipoUrl={editSipoUrl}
        goBackUrl={goBackUrlPage}
        goBackUrlDetail={goBackUrlDetail}
        isOther={isOther}
        items={items}
      />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared.displayName =
  'Research CivilUnion Detail Notifications Page component';

export default RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared;
